import { IAppComponent } from "../../Frame/IAppComponent";
import { app } from "../../Frame/App";

export class Login implements IAppComponent{
    initialize(): void {
        let frameHeader = document.querySelector(".frame-header") as HTMLElement;
        frameHeader?.classList.add("hidden");

        let frameFooter = document.getElementById("frameFooterContainer") as HTMLElement;
        frameFooter?.classList.remove("hidden");

    }
}

var userLogin = new Login();
app.addComponent(userLogin);